import GameStatesEnum from '../GameStatesEnum'
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";

export default class InitState extends BaseState {

  begin() {
    this.model.isFreespinsStarted = false; /// todo
    Signals.initGame.addOnce(this.onInitGame, this)
    Signals.gameMessage.dispatch('init')
  }

  onInitGame(data) {
    this.model.initRawData = data
    let gameState = GameStatesEnum.LOADING
    this.stateMachine.setState(gameState)
  }

  cleanUp() {
    Signals.initGame.remove(this.onInitGame, this)
  }

}
